module.exports = __webpack_public_path__ + "media/img/time-6455fa44.png";